class FakeSelect extends HTMLElement {
  constructor() {
    super();
    this.attachShadow({ mode: 'open' });
    this.shadowRoot.innerHTML = `
      <style id="base-styles">
        .fake-select {
          display: block;
          padding: 28px 16px 12px;
          cursor: pointer;
          display: flex; 
          align-items: center;
          gap: 16px;
          text-transform: uppercase;
          font-family: PFDin;
          font-size: 14px;
          letter-spacing: 1.8px;
        }
        .swatch {
          display: block;
          width: 16px;
          height: 16px;
          min-width: 16px;
          min-height: 16px;
          border-radius: 100%;
          border: 1px solid var(--balance);
        }
        .options {
          display: none;
          position: absolute;
          top: calc(100% + 8px);
          left: 0;
          border: 1px solid var(--balance);
          background: #fff;
          width: calc(100% - 2px);
          border-radius: 12px;
          max-height: min-content;
          overflow: hidden;
          box-shadow: 0 14px 28px rgba(0,0,0,0.25), 0 10px 10px rgba(0,0,0,0.22);
        }
        .options.open {
          display: block;
          z-index: 100;
        }
        .option {
          padding: 12px 24px;
          cursor: pointer;
          display: flex; 
          align-items: center;
          gap: 16px;
          text-transform: uppercase;
          font-family: PFDin;
          font-size: 12px;
          letter-spacing: 1.8px;
        }
        .option[data-out-of-stock="true"] {
          opacity: 0.6;
          cursor: not-allowed;
        } 
        .option:hover {
          background-color: var(--primary-light);
        }
        .option.line-through {
          text-decoration: line-through;
          opacity: 50%;
        }
        select {
          display: none;
        }
      </style>
      <style id="custom-styles"></style>
      <div class="fake-select"></div>
      <div class="options"></div>
      <slot></slot>
    `;

    this.fakeSelect = this.shadowRoot.querySelector('.fake-select');
    this.optionsContainer = this.shadowRoot.querySelector('.options');
    this.customStyles = this.shadowRoot.querySelector('#custom-styles');
    if (this.getAttribute('disabled')) this.fakeSelect.setAttribute('disabled', true);
  }

  static get observedAttributes() {
    return ['data-css'];
  }

  attributeChangedCallback(name, oldValue, newValue) {
    if (name === 'data-css') {
      this.applyCustomStyles();
    }
  }

  applyCustomStyles() {
    const customCSS = this.getAttribute('data-css') || '';
    this.customStyles.textContent = customCSS;
  }

  connectedCallback() {
    const realSelect = this.querySelector('select');
    if (!realSelect) {
      console.error('FakeSelect must wrap a real <select> element.');
      return;
    }

    this.applyCustomStyles();
    this._initializeOptions(realSelect);
    this.fakeSelect.addEventListener('click', () => {
      if (this.getAttribute('disabled')) return;
      this.optionsContainer.classList.toggle('open');
    });

    document.addEventListener('click', (e) => {
      if (!this.contains(e.target)) {
        this.optionsContainer.classList.remove('open');
      }
    });
  }

  _initializeOptions(realSelect) {
    const initialValue = realSelect.options[realSelect.selectedIndex];
    this.fakeSelect.innerHTML = `${initialValue.dataset.swatch ? `<img class="swatch" width="52" height="52" src="${initialValue.dataset.swatch}">` : ''} ${initialValue.textContent}`;
    [...initialValue.attributes].forEach(attr => this.setAttribute(attr.nodeName, attr.nodeValue));
    
    Array.from(realSelect.options).forEach((option) => {
      const swatch = option.dataset.swatch;
      const fakeOption = document.createElement('div');
      [...option.attributes].forEach(attr => fakeOption.setAttribute(attr.nodeName, attr.nodeValue));
      fakeOption.classList.add('option');
      fakeOption.innerHTML = `${swatch ? `<img class="swatch" width="52" height="52" src="${swatch}">` : ''} ${option.textContent}`;
      fakeOption.dataset.value = option.value;
      if (option.dataset.available == "false") fakeOption.classList.add('line-through')

      fakeOption.addEventListener('click', () => {
        if (fakeOption.getAttribute('disabled')) return;
        this.fakeSelect.innerHTML = `${swatch ? `<img class="swatch" width="52" height="52" src="${swatch}">` : ''} ${option.textContent}`;
        [...option.attributes].forEach(attr => this.setAttribute(attr.nodeName, attr.nodeValue));
        realSelect.value = option.value;
        realSelect.dispatchEvent(new Event('change', { bubbles: true }));
        this.optionsContainer.classList.remove('open');
      });

      this.optionsContainer.appendChild(fakeOption);
    });
  }
}

customElements.define('fake-select', FakeSelect);
